import React, { useState, useEffect } from "react";
import clienteAxios from "../../axios"; // Asegúrate de que la ruta sea la correcta
import ModalAgregarArticuloPedido from './ModalAgregarArticuloPedido';  // Importamos el modal con el nuevo nombre


const ArticulosPedido = ({ pedidoId }) => {
    const [articulos, setArticulos] = useState([]);
    const [nuevoArticulo, setNuevoArticulo] = useState({ articulo_menu_id: "", cantidad: 1, precio: 0 });
    const [editandoArticulo, setEditandoArticulo] = useState(null);
    const [busqueda, setBusqueda] = useState("");
    const [showAgregarArticuloModal, setShowAgregarArticuloModal] = useState(false);  // Controla la visibilidad del modal


    // Función para obtener los artículos de un pedido
    const obtenerArticulosPedido = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "articulos_pedido"
            });
            setArticulos(response.data.data[0].filter(item => item.pedido_id === pedidoId));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (pedidoId) {
            obtenerArticulosPedido();  // Obtener los artículos del pedido cuando se monta el componente
        }
    }, [pedidoId]);

    // Función para agregar un nuevo artículo
    const handleAgregarArticulo = async (e) => {
        e.preventDefault();
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Agregar",
                modulo: "articulos_pedido",
                pedido_id: pedidoId,
                articulo_menu_id: nuevoArticulo.articulo_menu_id,
                cantidad: nuevoArticulo.cantidad,
                precio: nuevoArticulo.precio
            });
            setNuevoArticulo({ articulo_menu_id: "", cantidad: 1, precio: 0 });
            obtenerArticulosPedido();  // Actualizar lista de artículos
        } catch (error) {
            console.log(error);
        }
    };

    // Función para editar artículo
    const handleEditarArticulo = (articulo) => {
        setEditandoArticulo(articulo);
    };

    // Función para guardar artículo editado
    const handleGuardarArticulo = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "articulos_pedido",
                id: editandoArticulo.id,
                pedido_id: editandoArticulo.pedido_id,
                articulo_menu_id: editandoArticulo.articulo_menu_id,
                cantidad: editandoArticulo.cantidad,
                precio: editandoArticulo.precio
            });
            setEditandoArticulo(null);
            obtenerArticulosPedido();  // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar artículo
    const handleEliminarArticulo = async (articuloId) => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "articulos_pedido",
                id: articuloId
            });
            obtenerArticulosPedido();  // Actualizar lista de artículos
        } catch (error) {
            console.log(error);
        }
    };

    const articulosFiltrados = articulos.filter(articulo =>
        articulo.precio.toString().includes(busqueda)
    );

    return (
        <div className="mt-4 ">
            <h4 className="text-lg font-semibold mb-4">Artículos del Pedido:</h4>



            <ul>
                {articulosFiltrados.map((articulo) => (
                    <li key={articulo.id} className="border-4 rounded p-2 mb-2">
                        {editandoArticulo && editandoArticulo.id === articulo.id ? (
                            <>
                                <div className="flex flex-col">
                                <h3 className=" font-semibold ">ID Artículo:</h3>
                                    <input
                                        type="text"
                                        value={editandoArticulo.articulo_menu_id}
                                        onChange={(e) => setEditandoArticulo({ ...editandoArticulo, articulo_menu_id: e.target.value })}
                                        className="border rounded-lg p-2"
                                        maxLength={10}
                                    />
                                    <h3 className=" font-semibold mt-2">Cantidad:</h3>
                                    <input
                                        type="number"
                                        value={editandoArticulo.cantidad}
                                        onChange={(e) => setEditandoArticulo({ ...editandoArticulo, cantidad: e.target.value })}
                                        className="border rounded-lg p-2 "
                                        maxLength={10}
                                    />
                                    <h3 className=" font-semibold mt-2">Precio:</h3>
                                    <input
                                        type="number"
                                        value={editandoArticulo.precio}
                                        onChange={(e) => setEditandoArticulo({ ...editandoArticulo, precio: e.target.value })}
                                        className="border rounded-lg p-2"
                                        maxLength={15}
                                    />

                                    <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={handleGuardarArticulo}
                                            className="bg-green-500 text-white px-4 py-1 rounded mr-2 w-40"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoArticulo(null)}
                                            className="bg-gray-500 text-white px-4 py-1 rounded w-40"
                                        >
                                            Cancelar
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <>
                                <span><strong>ID Artículo:</strong> {articulo.articulo_menu_id}</span><br />
                                <span><strong>Cantidad:</strong> {articulo.cantidad}</span><br />
                                <span><strong>Precio:</strong> {articulo.precio}</span><br />
                                <button
                                    onClick={() => handleEditarArticulo(articulo)}
                                    className="bg-gray-500 text-white px-2 py-1 rounded mr-2 hover:bg-gray-400"
                                >
                                    Editar
                                </button>
                                <button
                                    onClick={() => handleEliminarArticulo(articulo.id)}
                                    className="bg-red-600 text-white px-2 py-1 rounded hover:bg-red-500"
                                >
                                    Eliminar
                                </button>


                            </>
                        )}


                    </li>


                ))}

            </ul>
            {/* Botón para abrir el modal de agregar artículo */}
            <div className="flex">
                <button
                    onClick={() => setShowAgregarArticuloModal(true)}
                    className="bg-blue-500 text-white px-4 py-2 rounded mt-4 mb-2 hover:bg-blue-400 ">
                    Agregar Nuevo Artículo
                </button>
            </div>


            {/* Modal para agregar nuevo artículo */}
            <ModalAgregarArticuloPedido
                show={showAgregarArticuloModal}
                onClose={() => setShowAgregarArticuloModal(false)}
                pedidoId={pedidoId}
                onArticuloAgregado={obtenerArticulosPedido}  // Actualiza la lista de artículos al agregar
            />
        </div>


    );
};

export default ArticulosPedido;
